export default "__VITE_ASSET__B34ozp77__"